/** @format */

import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { CookiesProvider } from 'react-cookie';
import Loader from '@components/loader';

const JaProductsDisclaimer = lazy(
  () => import(/* webpackChunkName: "ja-products-disclaimer" */ './ja-products')
);

const Disclaimer = lazy(
  () => import(/* webpackChunkName: "disclaimer" */ './disclaimer')
);

/**
 * Build all disclaimers
 */
export const disclaimers = () => {
  /**
   * Get Current Disclaimer.
   */
  const getCurrentDisclaimer = (
    disclaimerId: string
  ): React.LazyExoticComponent<React.FC> | null => {
    let element = null;
    switch (disclaimerId) {
      case 'ja-products-disclaimer':
        element = JaProductsDisclaimer;
        break;
      case 'au-local-disclaimer':
      case 'tandem-disclaimer':
      case 'tr-disclaimer':
      case 'fr-ca-disclaimer':
      case 'en-ca-disclaimer':
        element = Disclaimer;
        break;
    }
    return element;
  };

  /**
   * Disclaimer Check.
   */
  const disclaimerCheck = (): void => {
    const disclaimers = document.querySelectorAll(
      '#fr-ca-disclaimer, #en-ca-disclaimer, #ja-products-disclaimer, #tandem-disclaimer, #au-local-disclaimer, #tr-disclaimer'
    );
    if (disclaimers.length > 0) {
      disclaimers.forEach((disclaimerElement) => {
        const CurrentDisclaimer = getCurrentDisclaimer(disclaimerElement.id);
        const root = createRoot(disclaimerElement);
        if (CurrentDisclaimer) {
          root.render(
            <Suspense fallback={<Loader />}>
              <CookiesProvider>
                <CurrentDisclaimer disclaimerId={disclaimerElement.id} />
              </CookiesProvider>
            </Suspense>
          );
        }
      });
    }
  };
  disclaimerCheck();
};
